import { Fragment } from "preact";
import { useUserOrderDetails } from "./useUserOrderDetails";
import { Heading } from "../../components";
import { useAppContext } from "../../contexts";
import LoggedMenu from "../../components/UserArea/LoggedMenu/loggedMenu";
import s from './userOrderDetails.module.css';
import { Link } from "preact-router";
import OrdersProgressBar from '../../routes/UserOrders/OrderCard/OrdersProgressBar/ordersProgressBar';
import CancelProgressBar from '../../routes/UserOrders/OrderCard/CancelProgressBar/cancelProgressBar';
import { voucherICon } from "../../assets";

const UserOrderDetails = (props) => {
    const { id } = props;

    // Destructured page logic data
    const {
        order,
        isFetching,
        formattedStatus,
        formattedMessage,
        formatDate,
        formatPrice,
        cancelData,
        convertEscapedHTML,
        descriptionIsOpen,
        handleDescriptionIsOpen,
    } = useUserOrderDetails({ id });

    const { accessibilityFont } = useAppContext();

    const {highContrast} = useAppContext();

    // Variable to store the main page content
    const mainContent = (
        <Fragment>
            <div className="container-fluid mt-[2rem] min-h-screen">
                <div className="sabin-container">
                    <Heading title={"Últimos pedidos"} />
                    <div className={"flex gap-[2.5rem]"}>
                        <LoggedMenu />
                        <div className={"w-full mt-[1.5rem] ml-[4rem] md:ml-0 font-museo "} >
                            <div className={`${s.card} ${highContrast ? "grayBackground" : "bg-light-gray"}`}>
                                <div className={'flex flex-col lg:w-full lg:flex-row lg:gap-[4rem]'}>
                                    <div className={'flex flex-col'}>
                                        <div className={'flex gap-[3px] font-bold'} style={{ fontSize: `${16 + accessibilityFont}px` }}>
                                            <span className={`text-[#636363] ${highContrast ? "highLabelFourth" : ""}`}>
                                                Status do Pedido:
                                            </span>
                                            <span className={`text-sabin-red-default ${highContrast ? "highTitleThird" : ""}`}>
                                                {formattedStatus}
                                            </span>
                                        </div>

                                        {['processing', 'scheduled', 'partially_scheduled', 'partially_applied', 'scheduled', 'complete', 'authorized', 'canceled'].includes(order?.status) ? (
                                            <p className={`text-[#666] py-[0.5rem] ${highContrast ? "highLabelFourth" : ""}`} style={{ fontSize: `${16 + accessibilityFont}px` }}>
                                                Número do pedido:&nbsp;
                                                <span className={`text-sabin-red-default ${highContrast ? "highTitleThird" : ""}`}>
                                                    {order.incrementId}
                                                </span>
                                                &nbsp;realizado em:&nbsp;
                                                <span>
                                                    {formatDate(order.createdAt)}
                                                </span>
                                            </p>
                                        ) : null}

                                        <p className={`text-[#666] ${highContrast ? "highTitleThird" : ""}`} style={{ fontSize: `${14 + accessibilityFont}px` }}>
                                            {formattedMessage}
                                        </p>

                                        <div className={'hidden lg:block mt-[1rem]'}>
                                            <div className={`${['canceled'].includes(order?.status) ? 'hidden' : ''}`}>
                                                <OrdersProgressBar orderStatus={order?.status} />
                                            </div>
                                            <div className={`hidden ${['processing_cancel', 'canceled'].includes(order.status) ? 'lg:block' : ''}`}>
                                                <span className={`font-museo font-bold text-sabin-red-default ${highContrast ? "highTitleThird" : ""}`}>
                                                    Serviços com pedido de cancelamento
                                                </span>
                                                <CancelProgressBar orderStatus={order?.status} />
                                            </div>
                                        </div>

                                        <div className={'flex flex-col gap-[1rem]'}>
                                            {['processing_cancel', 'canceled'].includes(order.status) ? (
                                                <div className={'flex flex-col bg-white border border-soft-gray rounded p-[1rem]'}>
                                                    <p className={'text-[#666] font-bold mb-[0.5rem]'} style={{ fontSize: `${16 + accessibilityFont}px` }}>
                                                        Solicitações de cancelamento
                                                    </p>
                                                    <span className={'text-[#666] font-bold'}>
                                                        Título: {cancelData[order.incrementId]?.titulo}
                                                    </span>
                                                    <span className={'text-[#666] font-bold'}>
                                                        Solicitado em: {cancelData[order.incrementId]?.data_criacao}
                                                    </span>
                                                    <span className={'text-[#666] font-bold'}>
                                                        Última atualização: {cancelData[order.incrementId]?.data_ultima_modificacao}
                                                    </span>
                                                    <span className={'text-[#666] font-bold'}>
                                                        Status: {cancelData[order.incrementId]?.status}
                                                    </span>

                                                    <div className="border border-gray rounded-lg mt-[0.5rem]">
                                                        <button
                                                            className="flex justify-between w-full text-left font-semibold mb-2 focus:outline-none p-[1rem] text-[#666]"
                                                            onClick={() => handleDescriptionIsOpen(!descriptionIsOpen)}
                                                        >
                                                            <span>
                                                                Descrição:
                                                            </span>
                                                            <svg
                                                                data-accordion-icon
                                                                className="w-6 h-6 shrink-0"
                                                                fill="currentColor"
                                                                viewBox="0 0 20 20"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    fill-rule="evenodd"
                                                                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                                    clip-rule="evenodd"
                                                                ></path>
                                                            </svg>
                                                        </button>
                                                        {descriptionIsOpen && (
                                                            <div className={'flex flex-col ml-[1rem] mb-[1rem]'}>
                                                                {convertEscapedHTML(
                                                                    cancelData[order.incrementId]?.descricao).map((item, index) => (
                                                                        <span key={index}>
                                                                            {item}
                                                                        </span>
                                                                    )
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            ) : null}

                                            {order?.items?.map((item, index) => (
                                                <div
                                                    key={item?.cartItemId || index}
                                                    className={'flex flex-col gap-[1rem] bg-white border border-soft-gray rounded p-[1rem]'}
                                                >
                                                    <div className={'flex flex-col gap-[1rem]'}>
                                                        <div className={'flex flex-col'}>
                                                            <p className={`uppercase text-sabin-red-default ${highContrast ? "highTitleThird" : ""} font-museo font-bold`} style={{ fontSize: `${16 + accessibilityFont}px` }}>
                                                                BENEFICIÁRIO:
                                                            </p>
                                                            <span>
                                                                {item.beneficiary?.nome}
                                                            </span>
                                                            <span>
                                                                CPF:{item.beneficiary?.cpf}
                                                            </span>
                                                        </div>
                                                        {item.typeService === "home_delivery" ? (
                                                            <div className={'flex flex-col'}>
                                                                <p className={`uppercase text-sabin-red-default ${highContrast ? "highTitleThird" : ""} font-museo font-bold`} style={{ fontSize: `${16 + accessibilityFont}px` }}>
                                                                    #VEMSABIN ATENDIMENTO MÓVEL:
                                                                </p>
                                                                <span>
                                                                    {item.scheduling?.address}
                                                                </span>
                                                                    <span>
                                                                    {item.scheduling?.neighborhood} - {item.scheduling?.cep}
                                                                </span>
                                                                    <span>
                                                                    {item.scheduling?.city}
                                                                </span>
                                                            </div>
                                                        ) : (
                                                            <div className={'flex flex-col'}>
                                                                <p className={`uppercase text-sabin-red-default ${highContrast ? "highTitleThird" : ""} font-museo font-bold`}
                                                                   style={{fontSize: `${16 + accessibilityFont}px`}}>
                                                                    UNIDADE:
                                                                </p>
                                                                <span>
                                                                    {item?.unityName}
                                                                </span>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div
                                                        className={`font-museo font-bold text-sabin-red-default ${highContrast ? "highTitleThird" : ""}`}
                                                        style={{fontSize: `${14 + accessibilityFont}px`}}>
                                                        Valor {order.priceLabel}&nbsp;
                                                        <span className={'text-black'}>
                                                            {formatPrice(order.grandTotal)}
                                                        </span>
                                                    </div>
                                                </div>
                                            ))}

                                            <div className={'flex flex-col bg-white border border-soft-gray rounded p-[1rem]'}>
                                                <p className={'font-bold text-[#666] mb-[0.5rem]'} style={{ fontSize: `${16 + accessibilityFont}px` }}>
                                                    Endereço de faturamento
                                                </p>
                                                <span className={`font-museo text-sabin-red-default ${highContrast ? "highTitleThird" : ""} uppercase font-bold`} style={{ fontSize: `${16 + accessibilityFont}px` }}>
                                                    {order?.addresses?.defaultBillingAddress?.firstname}
                                                </span>
                                                <span className={'font-museo'} style={{ fontSize: `${14 + accessibilityFont}px` }}>
                                                    {order?.addresses?.defaultBillingAddress?.street[0]} {order?.addresses?.defaultBillingAddress?.street[1]}
                                                </span>
                                                <span className={'font-museo'} style={{ fontSize: `${14 + accessibilityFont}px` }}>
                                                    {order?.addresses?.defaultBillingAddress?.street[2] ? `${order?.addresses?.defaultBillingAddress?.street[2]} - `  : ''}
                                                    {order?.addresses?.defaultBillingAddress?.postcode} 
                                                    - {order?.addresses?.defaultBillingAddress?.city}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'flex flex-col'}>
                                        <p 
                                            className={`font-bold text-[#666] py-[1rem] ${highContrast ? "highLabelFirst" : ""}`} 
                                            style={{ fontSize: `${16 + accessibilityFont}px` }}
                                        >
                                            O que deseja fazer?
                                        </p>

                                        <div className={`flex flex-col gap-[1rem] ${highContrast ? "highLabelFourth" : ""}`}>
                                            <div className={'flex flex-col'}>
                                                <p className={`uppercase text-sabin-red-default ${highContrast ? "highTitleThird" : ""} font-museo font-bold`} style={{ fontSize: `${16 + accessibilityFont}px` }}>
                                                    MÉTODO DE PAGAMENTO:
                                                </p>

                                                {order?.payment?.method === 'pix' ? (
                                                    <span>
                                                        Pix
                                                    </span>
                                                ) : (
                                                    <Fragment>
                                                        <span>
                                                            {(order?.payment?.method === 'Query_Cielo_Dc') ? 'Débito' : 'Cartão de Crédito'}
                                                        </span>
                                                        <span>
                                                            Transação: {order?.payment?.transaction}
                                                        </span>
                                                        <span>
                                                            Cartão: **** **** **** {order?.payment?.finalCardNumber}
                                                        </span>
                                                        {order?.payment?.method !== 'Query_Cielo_Dc' ? (
                                                            <Fragment>
                                                                <span>
                                                                    Bandeira: {order?.payment?.flag}
                                                                </span>
                                                                <span>
                                                                    Parcelamento: {order?.payment?.installments > 1 ? `${order?.payment?.installments} vezes` : order?.payment?.installments}
                                                                </span>
                                                            </Fragment>
                                                        ) : null}
                                                    </Fragment>
                                                )}
                                            </div>

                                            {order?.shipping?.invoice ? (
                                                <div className={'flex flex-col'}>
                                                    <p className={'uppercase text-sabin-red-default font-museo font-bold'} style={{ fontSize: `${16 + accessibilityFont}px` }}>
                                                        TRANSPORTE E MANUSEIO:
                                                    </p>
                                                    <span>
                                                        R$ {formatPrice(order?.shipping?.invoice)}
                                                    </span>
                                                </div>
                                            ) : null}

                                            {order?.grandTotal ? (
                                                <div className={'flex flex-col'}>
                                                    <p className={'uppercase text-sabin-red-default font-museo font-bold'} style={{ fontSize: `${16 + accessibilityFont}px` }}>
                                                        VALOR TOTAL:
                                                    </p>
                                                    <span>
                                                        R$ {formatPrice(order?.grandTotal)}
                                                    </span>
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <a
                                    className={`
                                        w-[15rem] rounded flex justify-center items-center bg-[#5C5F69] text-white py-[0.5rem] mb-[1rem] h-[3rem] 
                                        ${[ 'scheduled', 'partially_scheduled', 'partially_applied' ].includes(order.status) ? '' : ' hidden '}
                                    `}    
                                    style={{fontSize: `${14+accessibilityFont}px`}}
                                    href={`/voucher/order/printcustomer/id/${order.entityId}`}
                                    target={'_blank'}
                                    rel="noreferrer"
                                >
                                    <img src={voucherICon} className={'mr-[5px]'} />
                                    IMPRIMIR VOUCHER
                                </a>
                                <Link
                                    className={`w-[15rem] rounded flex justify-center items-center bg-sabin-red-default text-white py-[0.75rem] mb-[1rem] ${highContrast ? "highFormButtonSecond" : ""}`}
                                    style={{ fontSize: `${14 + accessibilityFont}px` }}
                                    href={`/meus-pedidos`}
                                >
                                    VOLTAR PARA MEUS PEDIDOS
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )

    return !isFetching ? (
        <Fragment>
            {mainContent}
        </Fragment>
    ) : null;
}

export default UserOrderDetails;
